import React from "react"
import Head from "next/head"
import Index from "../views/Home"

const index = () => {
  return (
    <div>
      <Head>
        <title>
          North West Region Virtual Care Clinic | Virtual Care in Ontario`s North West Region
        </title>
        <link rel="canonical" href="https://www.nwvirtualcare.ca" />
        <meta name="robots" content="follow, index" />
        <meta
          name="description"
          content="The North West Region Virtual Care Clinic is a Nurse Practitioner-led virtual care clinic that works with local health care providers to ensure patients can access more timely care. Patients can now access virtual care from all across the Ontario Health North West Region, from Kenora to Manitouwadge and Thunder Bay to Fort Severn."
        />
        <meta property="og:url" content="https://www.nwvirtualcare.ca" />
        <meta property="og:type" content="website" />
        <meta
          property="og:site_name"
          content="North West Region Virtual Care Clinic | Virtual Care in Ontario`s North West Region"
        />
        <meta
          property="og:title"
          content="North West Region Virtual Care Clinic | Virtual Care in Ontario`s North West Region"
        />
        <meta
          property="og:description"
          content="The North West Region Virtual Care Clinic is a Nurse Practitioner-led virtual care clinic that works with local health care providers to ensure patients can access more timely care. Patients can now access virtual care from all across the Ontario Health North West Region, from Kenora to Manitouwadge and Thunder Bay to Fort Severn."
        />
        <meta
          property="og:image"
          content="https://d3ryxmuvu4ye8d.cloudfront.net/images/nw-og-image.png"
        />
        <meta name="twitter:card" content="summary_large_image" />
        <meta
          name="twitter:title"
          content="North West Region Virtual Care Clinic | Virtual Care in Ontario`s North West Region"
        />
        <meta
          name="twitter:description"
          content="The North West Region Virtual Care Clinic is a Nurse Practitioner-led virtual care clinic that works with local health care providers to ensure patients can access more timely care. Patients can now access virtual care from all across the Ontario Health North West Region, from Kenora to Manitouwadge and Thunder Bay to Fort Severn."
        />
        <meta
          name="twitter:image:alt"
          content="North West Region Virtual Care Clinic Banner"
        ></meta>
        <meta
          name="twitter:image"
          content="https://d3ryxmuvu4ye8d.cloudfront.net/images/nw-og-image.png"
        />
      </Head>
      <Index />
    </div>
  )
}

export default index
